import React from "react";

import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { ReactComponent as EmptyDictionaryTabImage } from "src/images/empty-dictionary-tab.svg";
import { ReactComponent as PlusIcon } from "src/images/plus-white.svg";
import AnimatedDiv from "src/app/components/AnimatedDiv/AnimatedDiv";
import { Button } from "src/app/components/Button/Button";
import { ReactComponent as CircleArrowDownIcon } from "src/images/circle-angle-down.svg";
import { DictionaryItem } from "../../DictionaryTab";

import "./EmptyDictionaryTab.scss";

interface Props {
  showAssignDictionaryElementModal: () => void;
  showAddNewDictionaryElementModal: () => void;
  dictionaryData: DictionaryItem | undefined;
}

export default function EmptyDictionaryTab(props: Props) {
  const {
    showAssignDictionaryElementModal,
    dictionaryData,
    showAddNewDictionaryElementModal,
  } = props;

  const dictionaryElementName = dictionaryData?.wsDictionaryElementName;

  return (
    <AnimatedDiv className="empty-dictionary-tab">
      <EmptyDictionaryTabImage />
      <div className="empty-dictionary-tab__text">
        <IDHFormattedMessage
          id="ws_no_elements_have_been_assigned_to_this_creator"
          defaultMessage="No elements have been assigned to this creator.\n Add new or assign already added elements."
        />
      </div>
      <div className="empty-dictionary-tab__buttons">
        <Button
          variant="blue"
          size="small"
          onClick={showAddNewDictionaryElementModal}
        >
          <PlusIcon />
          <span>
            <IDHFormattedMessage id="ws_add_new" defaultMessage="Add new" />{" "}
            {dictionaryElementName}
          </span>
        </Button>
        <Button
          variant="white-with-light-grey-border"
          size="small"
          onClick={showAssignDictionaryElementModal}
        >
          <CircleArrowDownIcon />
          <span>
            <IDHFormattedMessage
              id="ws_select_existing_vendor"
              defaultMessage="Select existing"
            />{" "}
            {dictionaryElementName}
          </span>
        </Button>
      </div>
    </AnimatedDiv>
  );
}
